import React from "react";
import { format, addDays } from "date-fns";
import { formatDisplayDate } from "utils/dateFormat";
import invoiceBg from "../../../assets/img/invoiceBackground.jpg";

const PurchaseOrderTemplate = ({ printData, contentRef, referralInfo }) => {
  // Calculate values from entry data
  const entry = printData;
  // Calculate quantity (default to 1 if not specified, or calculate from amount)
  const quantity = entry?.quantity || 1;

  // Calculate unit price (referralAmount / quantity)
  const unitPrice = entry?.referralAmount
    ? Number(entry.referralAmount) - Number(entry.paidAmount)
    : 0;

  // Calculate subtotal (quantity * unit price)
  const subtotal = quantity * unitPrice;

  // Calculate GST (10% if GST is included)
  const gstAmount =
    entry?.gstIncluded === "Yes" || entry?.gstIncluded === true ? subtotal * 0.1 : 0;

  // Calculate total (subtotal + GST)
  const totalAmount = subtotal + gstAmount;

  // Generate PO Number (using entry ID or date)
  const poNumber = entry?.id
    ? `PO-${String(entry.id).padStart(4, "0")}`
    : `PO-${format(new Date(), "yyyyMMdd")}`;

  // Purchase Order Date (today)
  const poDate = formatDisplayDate(new Date());

  // Delivery Date (7 days from today, or use paidDate if available)
  //   const deliveryDate = entry?.paidDate
  //     ? formatDisplayDate(entry.paidDate)
  //     : formatDisplayDate(addDays(new Date(), 7));

  const deliveryDate = formatDisplayDate(new Date());

  // Reference (using description or receipt number)
  const reference = entry?.receiptNumber || entry?.description || "-";

  // Get client information
  const buyerName = referralInfo?.name;
  const buyerAddress = referralInfo?.address;
  const buyerABN = referralInfo?.abn;
  const buyerPhone = referralInfo?.mobileNumber;

  return (
    <div
      className="printContent"
      ref={contentRef}
      style={{
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        WebkitPrintColorAdjust: "exact",
        printColorAdjust: "exact",
      }}
    >
      <div className="purchase-order-box">
        <div className="flex flex-col justify-between h-full">
          <div>
            <div className="invoice-header">
              <div
                className="invoice-heading"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <div className="invoice-title" style={{ fontSize: "28px", fontWeight: "bold" }}>
                  PURCHASE ORDER
                </div>
                <div>
                  <img
                    src={process.env.PUBLIC_URL + "/logo.png"}
                    alt="Kothar Logo"
                    style={{
                      height: "60px",
                      width: "auto",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              </div>
              <div className="top-section" style={{ marginTop: "20px" }}>
                {/* Seller Information (Left) */}
                <div className="kothar-info">
                  <p className="font-semibold">Kothar Educational Services</p>
                  <p>273/398 Pitt Street, SYDNEY NSW 2000, AUSTRALIA</p>
                  {/* <p>ABN: 21650886301</p> */}
                </div>

                {/* Purchase Order Details (Middle) */}
                <div className="invoice-detail">
                  <div className="font-semibold">Purchase Order Date</div>
                  <div>{poDate}</div>

                  <div className="font-semibold">Delivery Date</div>
                  <div>{deliveryDate}</div>

                  <div className="font-semibold">Purchase Order Number</div>
                  <div>{poNumber}</div>

                  {/* <div className="font-semibold">Reference</div>
                  <div>{reference}</div> */}

                  {/* <div className="font-semibold">Buyer ABN</div>
                  <div>{buyerABN}</div> */}
                </div>

                {/* Buyer Information (Right) */}
                <div className="client-info">
                  <div className="font-semibold">{buyerName}</div>
                  <div>{buyerPhone}</div>
                </div>
              </div>
            </div>

            {/* Line Items Table */}
            <table>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>GST</th>
                  <th>Amount AUD</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{entry?.description || "-"}</td>
                  <td>{quantity.toFixed(2)}</td>
                  <td>{unitPrice.toFixed(2)}</td>
                  <td>
                    {entry?.gstIncluded === "Yes" || entry?.gstIncluded === true ? "10%" : "-"}
                  </td>
                  <td>{subtotal.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>

            {/* Summary of Charges */}
            <div className="sub-total">
              <p>
                Subtotal: &nbsp;&nbsp;&nbsp;&nbsp;
                <span>{Number(subtotal).toFixed(2)}</span>
              </p>
              <p>
                TOTAL GST 10%: &nbsp;&nbsp;&nbsp;&nbsp;
                <span>{Number(gstAmount).toFixed(2)}</span>
              </p>
            </div>
            <p className="total">
              TOTAL AUD: &nbsp;&nbsp;&nbsp;&nbsp;
              <span>{Number(totalAmount).toFixed(2)}</span>
            </p>
          </div>

          {/* Delivery Details Section */}
          <div className="payment-advice mb-24" style={{ marginTop: "40px" }}>
            <h2 className="font-bold" style={{ marginBottom: "15px", fontSize: "14px" }}>
              DELIVERY DETAILS
            </h2>
            <div style={{ fontSize: "12px" }}>
              <p>
                <span className="font-semibold">Delivery Address:</span> {buyerAddress}
              </p>
              <p>
                <span className="font-semibold">Attention:</span> {buyerName}
              </p>
              <p>
                <span className="font-semibold">Telephone:</span> {buyerPhone}
              </p>
              <p>
                <span className="font-semibold">Extra Instructions:</span> {entry?.comments || "-"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderTemplate;
